// @flow
import React, { useState } from 'react';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import NumericInput from 'react-numeric-input';
import { isUndefined } from 'lodash/fp';
import round from 'lodash/round';
import styled from '@emotion/styled';

import { TableRow, TableCell } from './Table';
import TableHead from './TableHead';
import { FANTASY_INSIDER_STARRED_BG_COLOR } from './OpenEntityRow';

type Props = {
  defaultExposure: number,
  entities: Array<Object>,
  onUpdateExposure: (playerId: string, exposure: number) => void
};

const header = [
  {
    field: 'insiderName',
    label: 'Name',
    size: 7,
    sortable: false
  },
  {
    field: 'insiderScoreUpdated',
    label: 'Projection',
    size: 2,
    sortable: false
  },
  {
    field: 'insiderExposure',
    label: 'Exposure%',
    size: 3,
    sortable: false
  }
];

const StyledTableRow = styled(TableRow)(({ isFavorite }) =>
  isFavorite ? { backgroundColor: FANTASY_INSIDER_STARRED_BG_COLOR } : {}
);

const ExposureTable = ({ defaultExposure, entities, onUpdateExposure }: Props) => {
  const Row = ({ index, style }: RowProps) => {
    const {
      isFavorite,
      insiderIdStr,
      insiderName,
      insiderScoreUpdated,
      insiderExposure
    } = entities[index];

    const [playerExposure, setPlayerExposure] = useState(
      isUndefined(insiderExposure) ? defaultExposure : insiderExposure
    );

    const [updated, setUpdated] = useState(false);

    const handleUpdate = val => {
      setPlayerExposure(val);
      setUpdated(true);
    };

    const handleUpdateSetting = () => {
      if (updated) {
        onUpdateExposure(
          insiderIdStr,
          'insiderExposure',
          round(parseFloat(playerExposure || '0'), 1)
        );
      }
    };

    return (
      <StyledTableRow
        className="is-mobile"
        key={insiderIdStr}
        style={style}
        isFavorite={isFavorite}
      >
        <TableCell className="is-7">{insiderName}</TableCell>
        <TableCell className="is-2">{insiderScoreUpdated}</TableCell>
        <TableCell className="is-3">
          <NumericInput
            name="exposure"
            min={0}
            max={100}
            step={1}
            size={6}
            onChange={handleUpdate}
            onBlur={handleUpdateSetting}
            value={playerExposure}
          />
        </TableCell>
      </StyledTableRow>
    );
  };

  return (
    <div>
      <TableHead columns={header} hasScrollbar />
      <div style={{ flex: '1 1 auto' }}>
        <AutoSizer disableHeight>
          {({ width }) => (
            <List height={400} itemCount={entities.length} itemSize={40} width={width}>
              {Row}
            </List>
          )}
        </AutoSizer>
      </div>
    </div>
  );
};

export default ExposureTable;
